<template>
  <div class="page_wrapper">
    <p></p>
    <div class="box">
      <h1 class="text_align_center rsvp">RSVP</h1>
      <div class="deadline text_align_center">
        Deadline: August 28st, 2020
      </div>
    <div class="card-body" v-if="false && (!rsvped || editing)">
      <form @submit.prevent="addRsvp">
        <div class="form-group">
          <div class="form-item">
            <label>Are you attending?</label>
            <select
                required
                class="form-control"
                v-model="attending.value"
                @change="onChangeAttending(attending.value)"
            >
              <option
                  v-for="(option, index) in attending"
                  :key="index"
                  :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
          </div>
        </div>

        <div v-if="attending.value">
          <div class="form-group">
            <div class="form-item">
              <label>How many people are attending?</label>
              <select
                  required
                  class="form-control"
                  v-model="selected"
                  @change="onChangeNumber(selected.number)"
              >
                <option
                    v-for="n in 8"
                    :key="n"
                    :value="{ number: n }"
                >
                  {{ n }}
                </option>
              </select>
            </div>
          </div>
          <br/>
          <div class="form-group" v-for="n in Number(selected.number)">
            <div class="form-item">
              <label>First Name:</label>
              <input
                  required
                  type="text"
                  class="form-control names"

                  v-model="newRsvp.firstName[n-1]"
                  :index="n"
                  :key="n"
              />
            </div>
            <div class="form-item">
              <label>Last Name:</label>
              <input
                  required
                  type="text"
                  class="form-control names"

                  v-model="newRsvp.lastName[n-1]"
                  :index="n"
                  :key="n"
              />
            </div>
            <div class="form-item">
            <label>What foods do you eat?</label>
            <select
                required
                class="form-control"
                v-model="newRsvp.diet[n-1]"
            >
              <option
                  v-for="(option, index) in diet"
                  :key="index"
                  :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
          </div>
              <div class="form-item"  v-if="newRsvp.diet[n-1] == 3">
                <label>Dietary Restrictions:</label>
                <input
                    required
                    type="text"
                    class="form-control"
                    v-model="newRsvp.dietRestrictions[n-1]"
                />
              </div>
            <br/>
          </div>
          </div>
        <div v-if="attending.value === false">
          <div class="form-group">
            <div class="form-item">
            <label>First Name:</label>
            <input
                required
                type="text"
                class="form-control names"
                v-model="newRsvp.firstName[0]">
          </div>
          <div class="form-item">
            <label>Last Name:</label>
            <input
                required
                type="text"
                class="form-control names"

                v-model="newRsvp.lastName[0]"
            />
          </div>
          </div>
        </div>
        <div class="form-group">
          <input
              type="submit"
              class="btn btn-submit"
              value="Submit"
          />
        </div>
      </form>
    </div>
      <div v-else-if="!rsvped">
        <h4>If you have not yet RSVPed or need to change your RSVP, please call Max or Christina.</h4>
      </div>
      <div v-else>
        <h4>Thanks for your RSVP</h4>
        <p></p>
        <p v-if="data_got.attending">
          You you attending?
          <br/>Hellz Yeah!
        </p>
        <p v-else>
          You you attending?<br/>
          I, {{data_got.firstname_list[0]}} {{data_got.lastname_list[0]}} the Thrid, am... not really feeling it.
        </p>
        <h5>Who's attending?</h5>
        <div v-if="data_got.attending" v-for="n in data_got.firstname_list.length">
          <p v-if="data_got.diet_num[n-1]===1">
            {{ data_got.firstname_list[n-1] }} {{ data_got.lastname_list[n-1] }}
            <br/>
            will be on a see food diet. See any food and eat all of it!
          </p>
          <p v-if="data_got.diet_num[n-1]===2">
            {{ data_got.firstname_list[n-1] }} {{ data_got.lastname_list[n-1] }}
            <br/>
            plans to get in a fist fight with a farm rabbit over the last carrot.</p>
          <p v-if="data_got.diet_num[n-1]===3">
            {{ data_got.firstname_list[n-1] }} {{ data_got.lastname_list[n-1] }}
            <br/>
            is broken in many ways.<br/> More relevant {{ data_got.firstname_list[n-1] }} can't have "{{data_got.diet_rules[n-1]}}"
          </p>
        </div>
<!--        <button class="btn" @click="onClickEdit">Edit</button>-->
      </div>
    </div>
  </div>
</template>
<script>

import Firebase from '../firebase.js';
import Swal from 'sweetalert2';

export default {
name: "RSVP",
    firebase: {rsvp: null//Firebase.db.ref("rsvp"),
},
data () {
  return {
    attending: [
      { text: 'Yes, I will be physically there' , value: true },
      { text: 'No, but I might be spiritually there' , value: false },
    ],
    rsvped: false,
    editing: false,
    data_got: null,
    selected: {
      number: 2,
    },
    newRsvp: {
      isAttending: "",
      firstName: [],
      lastName: [],
      dietRestrictions:[],
      diet:[],
      type: String,
    },
    diet: [
      { text: 'I eat all foods' , value: 1 },
      { text: 'I only eat veggie tables' , value: 2 },
      { text: 'Some foods and I don\'t get along' , value: 3 },
    ],
    user: {
      loggedIn: false,
      data: {}
    }
  }
},
methods: {
  addRsvp() {
    Firebase.db.ref('rsvp/' + this.user.data.uid).set({
      username: this.user.data.displayName,
      email: this.user.data.email,
      profile_picture : this.user.data.photoURL,
      attending: this.newRsvp.isAttending,
      firstname_list: this.newRsvp.firstName,
      lastname_list: this.newRsvp.lastName,
      diet_num: this.newRsvp.diet,
      diet_rules: this.newRsvp.dietRestrictions
    });
    this.showAlert();
  },
  showAlert() {
    //alert(JSON.stringify(this.newRsvp))
    Swal.fire({
      title: "Thank you!",
      text: "",
      icon: "success",
      showConfirmButton: true,
    }).then(() => {
      this.$router.push('/')
    });
  },
  onChangeAttending(value) {
    this.newRsvp.isAttending = value;
  },
  onChangeNumber(value){
    this.newRsvp.firstName.length=value;
    this.newRsvp.lastName.length=value;
    this.newRsvp.diet.length=value;
    this.newRsvp.dietRestrictions.length=value;
  },
  onClickEdit() {
    this.newRsvp.isAttending = this.data_got.attending;
    this.attending.value=this.data_got.attending;
    this.newRsvp.firstName = this.data_got.firstname_list;
    this.newRsvp.lastName = this.data_got.lastname_list;
    this.newRsvp.diet = this.data_got.diet_num;
    this.newRsvp.dietRestrictions = this.data_got.diet_rules;
    this.selected.number = this.data_got.lastname_list.length;
    this.editing = true;
  },
},
  mounted: function() {
    Firebase.auth.onAuthStateChanged( user => {
      if (user) {
        this.user.loggedIn = true;
        this.user.data = user;
        this.rsvped = false;
        Firebase.db.ref('rsvp/' + this.user.data.uid).once('value').then((snapshot) => {
          if (snapshot.val()) {
            this.rsvped = true;
            this.data_got = snapshot.val();
            //alert(JSON.stringify(snapshot.val()));
          }
        }).catch((err) => {console.log(err)});
      }
      else {
        this.user.loggedIn = false;
        this.user.data = {};
      }
    })
  }
}
</script>

<style scoped>
</style>
